// extracted by mini-css-extract-plugin
export default {"modal":"BankIDLoginModal_modal__FhYlo","backdrop":"BankIDLoginModal_backdrop__7JgWe","visible":"BankIDLoginModal_visible__etPje","qrCanvas":"BankIDLoginModal_qrCanvas__xXPvi"};